import _styled from "@emotion/styled/base";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { connect } from 'react-redux';
import { isNil } from 'lodash';
import { deleteAlert } from '../../actions/alert';
import AlertsView from '../view-alerts';
const duration = 200;
const getOpacityFromStatus = props => {
  const value = {
    entering: 1,
    entered: 1,
    exiting: 0.01,
    exited: 0.01
  }[props.status];
  return isNil(value) ? 1 : value;
};
const TransitionWrapper = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e152g52l0"
} : {
  target: "e152g52l0",
  label: "TransitionWrapper"
})("width:100%;opacity:0;opacity:", getOpacityFromStatus, ";transition:opacity ", duration, "ms linear;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
class AlertsTransitionManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      in: false
    };
  }
  static getDerivedStateFromProps(props, state) {
    return props.alertsRemoved.includes(props.alert.id) ? {
      ...state,
      in: false
    } : state;
  }
  componentDidMount() {
    // A slight delay is required to trigger the transition animation
    window.setTimeout(() => {
      this.setState({
        in: true
      });
    }, 50);
  }
  componentDidUpdate() {
    if (this.state.in === false) {
      window.setTimeout(() => {
        this.props.deleteAlert(this.props.alert.id);
      }, duration);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(Transition, {
      in: this.state.in,
      timeout: duration
    }, status => /*#__PURE__*/React.createElement(TransitionWrapper, {
      status: status
    }, /*#__PURE__*/React.createElement(AlertsView, {
      alert: this.props.alert,
      removeAlert: this.props.removeAlert,
      disableRemove: !this.state.in
    })));
  }
}
const mapStateToProps = _ref => {
  let {
    alert
  } = _ref;
  return {
    alertsRemoved: alert.alertsRemoved
  };
};
const mapDispatchToProps = dispatch => ({
  deleteAlert: alertId => dispatch(deleteAlert(alertId))
});
AlertsTransitionManager.propTypes = {
  alert: PropTypes.object.isRequired,
  removeAlert: PropTypes.func.isRequired,
  deleteAlert: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertsTransitionManager);